import config from '@/config'
import request from './request'

export default {
  /**
   * 获取登录用户信息
   */
  getLoginUser () {
    return request({
      type: 'get',
      host: config.accountServer,
      url: 'serv/v1/user/auth?t=' + Date.now()
    })
  }
}
